import React from "react";
import { useTranslation } from "react-i18next";

export default function ProductTypeItem(props) {
    const { t } = useTranslation();
    const { value, name_t, onClick, disabled } = props;

    return (
        <button type="button" className="wizard-product-item" onClick={onClick} disabled={disabled === true}>
            <span className="text-left">{t(name_t)}</span>
            <img className={value} src={`/img/wizard/wizard-${value}.svg`} alt="" />
        </button>
    );
}
